import React from "react";
import { Popover, Avatar, Tag, Typography, Button } from "antd";
import { IBettingWebsitePaymentGatway } from "../../../../types/BettingWebsite.PaymentGateway";
import { Link } from "react-router-dom";
import { EditOutlined } from "@ant-design/icons";
import { PAYMENT_METHOND_CLOUD_URL } from "../../../../lib/env";

const { Text } = Typography;

type Props = {
  gateways: IBettingWebsitePaymentGatway[];
  currentLang?: "En" | "Ar" | "Fr";
  id: string;
  page: number;
  pageSize: number;
};

export const PaymentGatewaysPopover: React.FC<Props> = ({
  gateways,
  currentLang = "En",
  id,
  page,
  pageSize,
}) => {
  const content = (
    <div className="space-y-2 max-w-xs">
      {gateways.map((gateway) => (
        <div key={gateway.id} className="flex items-center gap-3">
          <Avatar
            src={PAYMENT_METHOND_CLOUD_URL + gateway.Logo}
            size="small"
            alt={gateway.PaymentGatwayName[currentLang]}
          />
          <Text>{gateway.PaymentGatwayName[currentLang]}</Text>
        </div>
      ))}
    </div>
  );

  return (
    <Popover
      title={
        <div className="flex flex-row w-full justify-between border-b pb-0.5">
          <span>Payment Gateways</span>
          <Link
            to={`/betting-websites/edit-payment-gateways/${id}?page=${
              page + 1
            }&pageSize=${pageSize}`}
          >
            <Button size="small" type="link" icon={<EditOutlined />} />
          </Link>
        </div>
      }
      content={content}
      trigger="hover"
      placement="right"
    >
      <Tag color="gold" className="cursor-pointer">
        Show Gateways
      </Tag>
    </Popover>
  );
};
